'use strict';

var _commafy = require('commafy');

var _commafy2 = _interopRequireDefault(_commafy);

var _BookingRequest = require('./virtuals/BookingRequest');

var _BookingRequest2 = _interopRequireDefault(_BookingRequest);

var _AddOn = require('./virtuals/AddOn');

var _AddOn2 = _interopRequireDefault(_AddOn);

var _currencies = require('./enums/currencies');

var _currencies2 = _interopRequireDefault(_currencies);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants
var MINIMUM_SPEND = 25000;

// lodash

var DEFAULT_CURRENCY = 'USD';

/**
 * Return the full price breakdown for a request
 *
 * @param {Request} request
 * @return {Object}
 */

function fullPriceBreakdownCents(request) {
  var $foodAndBeverageTotal = foodAndBeverageTotal(request);
  var $nonFoodAndBeverageTotal = nonFoodAndBeverageTotal(request);
  var $extraToMeetMinimumSpend = extraToMeetMinimumSpend(request);
  var $roomFee = roomFee(request);
  var $menuAndDrinkTotal = menuAndDrinkTotalCents(request);
  var $adminFee = adminFee(request);
  var $adminFeePercentage = adminFeePercentage(request);
  var $foodAndBeverageTax = foodAndBeverageTax(request);
  var $nonFoodAndBeverageTax = nonFoodAndBeverageTax(request);
  var $gratuity = gratuity(request);
  var $gratuityPercentage = gratuityPercentage(request);
  var $nonTaxableTotal = nonTaxableTotal(request);
  var $customFees = customFees(request);
  var $customFeesList = customFeesList(request);
  var $total = total(request);

  var $deposit = deposit(request, $total);
  var $foodBeverageMin = foodBeverageMin(request);
  var $balanceOutstanding = balanceOutstanding(request, $total);
  var $overageTotal = overageTotal(request);
  var $extraCharge = extraChargeAmount(request);
  var $refund = refundedAmount(request);
  var $amountPaid = amountPaid(request);

  var $totalWithoutTaxes = $foodAndBeverageTotal + $nonFoodAndBeverageTotal + $nonTaxableTotal + $customFees + $adminFee + $roomFee;
  var $totalWithoutTaxesAndFees = $foodAndBeverageTotal + $roomFee + $nonFoodAndBeverageTotal + $nonTaxableTotal;

  var $ownerCommission = ownerCommission(request);

  var $bookingFee = bookingFee(request);
  var $cardFee = cardFee(request);

  var $payout = payout(request);

  return {
    adminFee: $adminFee,
    adminFeePercentage: $adminFeePercentage,
    extraCharge: $extraCharge,
    refund: $refund,
    amountPaid: $amountPaid,
    balanceOutstanding: $balanceOutstanding,
    bookingFee: $bookingFee,
    cardFee: $cardFee,
    deposit: $deposit,
    extraToMeetMinimumSpend: $extraToMeetMinimumSpend,
    foodBeverageMin: $foodBeverageMin,
    foodAndBeverageTax: $foodAndBeverageTax,
    foodAndBeverageTotal: $foodAndBeverageTotal,
    gratuity: $gratuity,
    gratuityPercentage: $gratuityPercentage,
    menuAndDrinkTotal: $menuAndDrinkTotal,
    nonFoodAndBeverageTax: $nonFoodAndBeverageTax,
    nonFoodAndBeverageTotal: $nonFoodAndBeverageTotal,
    nonTaxableTotal: $nonTaxableTotal,
    overageTotal: $overageTotal,
    payout: $payout,
    roomFee: $roomFee,
    customFeesList: $customFeesList,
    customFees: $customFees,
    total: $total,
    totalTax: $foodAndBeverageTax + $nonFoodAndBeverageTax,
    totalWithoutTaxes: $totalWithoutTaxes,
    totalWithoutTaxesAndFees: $totalWithoutTaxesAndFees,
    ownerCommission: $ownerCommission
  };
}

/**
 * Return the food and beverage total for the request without any taxes, fees,
 * etc.
 *
 * @param {Request} request
 * @return {Number} cents
 */

function foodAndBeverageTotal(request) {
  var total = 0;

  // Menu and Drinks
  var menuDrinkTotal = menuAndDrinkTotalCents(request);
  if (menuDrinkTotal) {
    total += menuDrinkTotal;
  }

  // Room fee
  var extraCents = extraToMeetMinimumSpend(request);
  if ((0, _lodash.isNumber)(extraCents)) {
    total += extraCents;
  }

  return total;
}

/**
 * Sums up the overages in a request, multiplying each's amountCents by its quantity
 *
 * @param {Request}
 * @return {Number}
 */
function overageTotal(request) {
  var overages = (0, _lodash.get)(request, 'data.payment.overages', []);
  var overageTotal = (0, _lodash.reduce)(overages, function (acc, curr) {
    var cost = curr.amountCents * curr.quantity;
    return acc + (_isFinite(cost) ? cost : 0);
  }, 0);
  return overageTotal;
}

/**
 * @param {Request} bookingRequest
 * @return {Number} menuDrinkTotal, cents
 */
function menuAndDrinkTotalCents(request) {
  var menuDrinkTotal = 0;
  var theMenu = (0, _lodash.get)(request, 'data.menu');
  if (theMenu) {
    var menuTotalCostCents = theMenu.pricePerGuestCents * theMenu.numGuests;
    menuDrinkTotal += _isFinite(menuTotalCostCents) ? Math.round(menuTotalCostCents) : 0;
  }
  // Drinks
  if ((0, _lodash.get)(request, 'data.drinks')) {
    (0, _lodash.each)(request.data.drinks, function (drink) {
      menuDrinkTotal += getDrinkPrice(drink);
    });
  }

  // AddOns

  var fbAddOns = (0, _lodash.filter)((0, _lodash.get)(request, 'data.addOns'), function (addOn) {
    return !addOn.isDeleted && addOn.taxType === 'FOOD_AND_BEVERAGE';
  });

  (0, _lodash.each)(fbAddOns, function (addOn) {
    var price = _AddOn2.default.totalCostCents(addOn);
    menuDrinkTotal += _isFinite(price) ? price : 0;
  });

  var overageCents = overageTotal(request);
  if (overageCents && _isFinite(overageCents)) {
    menuDrinkTotal += overageCents;
  }
  return menuDrinkTotal;
}

function getDrinkPrice(drink) {
  if ((0, _lodash.get)(drink, 'payAtTheVenue') || (0, _lodash.get)(drink, 'isDeleted')) {
    return 0;
  }

  var priceCents = drink.costPerGuestCents * drink.numGuests;
  return _isFinite(priceCents) ? Math.round(priceCents) : 0;
}

/**
 * Return the non-F&B total for the request without any taxes, fees,
 * etc. AddOns that don't have a `taxType` property will be included here as well.
 *
 * @param {Request} request
 * @return {Number} cents
 */

function nonFoodAndBeverageTotal(request) {
  var total = 0;
  if ((0, _lodash.get)(request, 'data.addOns')) {
    var nonFbAddOns = (0, _lodash.filter)(request.data.addOns, function (addOn) {
      return !addOn.isDeleted && (!addOn.taxType || addOn.taxType === 'NON_FOOD_AND_BEVERAGE');
    });

    (0, _lodash.each)(nonFbAddOns, function (addOn) {
      var price = _AddOn2.default.totalCostCents(addOn);
      total += _isFinite(price) ? Math.round(price) : 0;
    });
  }
  return total;
}

/**
 * Gets the total of non taxable items in a request (exception to the rule)
 *
 * @param {Request}
 * @return {Number}
 */
function nonTaxableTotal(request) {
  var total = 0;

  // Addons
  var nonTaxableAddOns = (0, _lodash.filter)((0, _lodash.get)(request, 'data.addOns'), function (addOn) {
    return !addOn.isDeleted && addOn.taxType === 'NONE';
  });
  (0, _lodash.each)(nonTaxableAddOns, function (addOn) {
    var price = _AddOn2.default.totalCostCents(addOn);
    total += _isFinite(price) ? Math.round(price) : 0;
  });

  return total;
}

function customFee(_ref) {
  var request = _ref.request,
      fee = _ref.fee;

  if (fee.feeType === 'flat') {
    return fee.value;
  }

  if (fee.feeType === 'percentage') {
    var _total = 0;
    var feePercentage = fee.value / 100;

    if (fee.appliesTo.fb) {
      _total += foodAndBeverageTotal(request) * feePercentage;
    }

    if (fee.appliesTo.admin) {
      _total += adminFee(request) * feePercentage;
    }

    if (fee.appliesTo.nonFb) {
      _total += nonFoodAndBeverageTotal(request) * feePercentage;
    }

    if (fee.appliesTo.roomFee) {
      _total += roomFee(request) * feePercentage;
    }

    return Math.round(_total);
  }
}

function customFees(request) {
  var fees = (0, _lodash.get)(request, 'venue.data.customFees', []);
  return fees.reduce(function (total, fee) {
    var calculatedFee = customFee({ request: request, fee: fee });
    return total + Math.round(calculatedFee);
  }, 0);
}

function customFeesList(request) {
  var fees = (0, _lodash.get)(request, 'venue.data.customFees', []);
  return fees.map(function (fee) {
    return {
      name: fee.name,
      value: customFee({ request: request, fee: fee }),
      percentage: fee.feeType === 'percentage' ? fee.value : null
    };
  });
}

/**
 * Round fees first to avoid fractional cents creating inaccurate results.
 */

function adminFee(request) {
  var total = 0;
  if ((0, _lodash.get)(request, 'venue.data.fees.admin')) {
    var fee = (0, _lodash.get)(request, 'venue.data.fees.admin') / 100;

    if ((0, _lodash.get)(request, 'venue.data.feeApplication.nonFb.admin')) {
      total += Math.round(nonFoodAndBeverageTotal(request) * fee);
    }

    if ((0, _lodash.get)(request, 'venue.data.feeApplication.fb.admin')) {
      total += Math.round(foodAndBeverageTotal(request) * fee);
    }

    if ((0, _lodash.get)(request, 'venue.data.feeApplication.roomFee.admin')) {
      total += Math.round(roomFee(request) * fee);
    }
  }
  return total;
}

function adminFeePercentage(request) {
  return (0, _lodash.get)(request, 'venue.data.fees.admin', 0);
}

/**
 * Return the tax on F&B cost for the request.
 * Round each fee to the nearest cent first to avoid fractional cents creating innacurate totals.
 */

function foodAndBeverageTax(request) {
  var total = 0;
  if ((0, _lodash.get)(request, 'venue.data.fees.tax')) {
    var fee = (0, _lodash.get)(request, 'venue.data.fees.tax') / 100;
    // fb tax always applies to F & B
    total += Math.round(foodAndBeverageTotal(request) * fee);
    if ((0, _lodash.get)(request, 'venue.data.feeApplication.admin.tax')) {
      total += Math.round(adminFee(request) * fee);
    }
    if ((0, _lodash.get)(request, 'venue.data.feeApplication.roomFee.tax')) {
      total += Math.round(roomFee(request) * fee);
    }

    if ((0, _lodash.get)(request, 'venue.data.customFees.length')) {
      var taxableFees = (0, _lodash.get)(request, 'venue.data.customFees', []).filter(function (fee) {
        return fee.taxType === 'tax';
      });

      total += taxableFees.reduce(function (total, fee) {
        var calculatedFee = customFee({ request: request, fee: fee });
        return total + Math.round(calculatedFee);
      }, 0) * fee;
    }
  }
  return total;
}

/**
 * Return the tax on non-F&B cost for the request.
 * Round each fee to the nearest cent first to avoid fractional cents creating innacurate totals.
 */

function nonFoodAndBeverageTax(request) {
  var total = 0;
  if ((0, _lodash.get)(request, 'venue.data.fees.nonfbTax')) {
    var fee = (0, _lodash.get)(request, 'venue.data.fees.nonfbTax') / 100;
    // non Fb tax will always apply to non fb
    total += nonFoodAndBeverageTotal(request) * fee;
    if ((0, _lodash.get)(request, 'venue.data.feeApplication.admin.nonfbTax')) {
      total += Math.round(adminFee(request) * fee);
    }
    if ((0, _lodash.get)(request, 'venue.data.feeApplication.roomFee.nonfbTax')) {
      total += Math.round(roomFee(request) * fee);
    }

    if ((0, _lodash.get)(request, 'venue.data.customFees.length')) {
      var taxableFees = (0, _lodash.get)(request, 'venue.data.customFees', []).filter(function (fee) {
        return fee.taxType === 'nonfbTax';
      });

      total += taxableFees.reduce(function (total, fee) {
        var calculatedFee = customFee({ request: request, fee: fee });
        return total + Math.round(calculatedFee);
      }, 0) * fee;
    }
  }
  return total;
}

/**
 * Return the gratuity total for the request
 */

function gratuity(request) {
  var requestGratuity = (0, _lodash.get)(request, 'data.gratuityPercentage');
  if (_isFinite(requestGratuity)) {
    var fee = (0, _lodash.get)(request, 'data.gratuityPercentage') / 100;
    return calc(fee);
  } else if (_isFinite((0, _lodash.get)(request, 'venue.data.fees.gratuityPercentage'))) {
    var venueFee = request.venue.data.fees.gratuityPercentage / 100;
    return calc(venueFee);
  }
  return 0;

  function calc(num) {
    var total = 0;
    total += Math.round(foodAndBeverageTotal(request) * num);
    if ((0, _lodash.get)(request, 'venue.data.feeApplication.nonFb.gratuity')) {
      total += Math.round(nonFoodAndBeverageTotal(request) * num);
    }
    if ((0, _lodash.get)(request, 'venue.data.feeApplication.admin.gratuity')) {
      total += Math.round(adminFee(request) * num);
    }
    if ((0, _lodash.get)(request, 'venue.data.feeApplication.roomFee.gratuity')) {
      total += Math.round(roomFee(request) * num);
    }

    var customFees = (0, _lodash.get)(request, 'venue.data.customFees', []);

    var customFeeTotal = customFees.filter(function (fee) {
      return fee.appliedTo.gratuity;
    }).reduce(function (total, fee) {
      var calculatedFee = customFee({ request: request, fee: fee });
      return total + Math.round(calculatedFee);
    }, 0);

    total += Math.round(customFeeTotal * num);

    return total;
  }
}

function gratuityPercentage(request) {
  return (0, _lodash.get)(request, 'data.gratuityPercentage', 0);
}

/**
 * Return the Food & Beverage minimum for a space based on the available timeslots
 * @param {Space} space
 * @return {String}
 */

function fbMinRangeDollars(space) {
  // Return early if hidden
  if ((0, _lodash.get)(space, 'data.hidden.fbMin')) {
    return 'Inquire to confirm minimum spend';
  }

  var slots = (0, _lodash.get)(space, 'data.timeSlots', []);
  var min;
  var max;

  slots.forEach(function (slot) {
    var fbMin = (0, _lodash.get)(slot, 'terms.foodBeverageMin');
    if (fbMin) {
      if (!min && !max) {
        min = fbMin;
        max = fbMin;
      } else {
        min = fbMin < min ? fbMin : min;
        max = fbMin > max ? fbMin : max;
      }
    }
  });

  if (!min && max) {
    return '$ ' + (0, _commafy2.default)(max);
  }

  if ((0, _lodash.isNil)(min)) {
    return '';
  }
  if (!min) {
    return 'No minimum spend';
  }
  max = max === min ? null : max.toFixed(0);
  min = min.toFixed(0);
  var ret = '$' + (0, _commafy2.default)(min);
  if (max) {
    ret += ' - $' + (0, _commafy2.default)(max);
  }
  return ret;
}

/**
 * Return the Room Fee range for a space based on the available timeslots
 * @param {Space} space
 * @return {String}
 */

function roomFeeRange(space) {
  var slots = (0, _lodash.get)(space, 'data.timeSlots', []);
  var min = void 0;
  var max = void 0;

  slots.forEach(function (slot) {
    var roomFee = (0, _lodash.get)(slot, 'terms.roomFeeCents');
    if (roomFee) {
      if (!min && !max) {
        min = roomFee;
        max = roomFee;
      } else {
        min = roomFee < min ? roomFee : min;
        max = roomFee > max ? roomFee : max;
      }
    }
  });

  if (!min && max) {
    return '$ ' + (0, _commafy2.default)(max / 100);
  }

  if ((0, _lodash.isNil)(min)) {
    return '';
  }

  if (!min) {
    return '';
  }

  max = max === min ? null : max.toFixed(0);
  min = min.toFixed(0);
  var ret = '$' + (0, _commafy2.default)(min / 100);
  if (max) {
    ret += ' - $' + (0, _commafy2.default)(max / 100);
  }
  return ret;
}

/**
 * Extra to meet minimum spend
 * @param {request}
 * @return {Number}
 */

function extraToMeetMinimumSpend(request) {
  var fbMinCents = foodBeverageMin(request);
  var fbSubtotalCents = menuAndDrinkTotalCents(request);

  var fee = fbMinCents - fbSubtotalCents;
  return fee > 0 ? Math.round(fee) : 0;
}

/**
 * Room fee for a request
 *
 * @params {Request} request
 * @return {Number}
 */
function roomFee(request) {
  var roomFee = (0, _lodash.get)(request, 'host.roomFeeCents');
  return (0, _lodash.isFinite)(roomFee) ? roomFee : 0;
}

/**
 * deposit - ROUNDED
 *
 * @param {Request} request
 * @param {Number} totalCents
 * @return {Number}
 */
function deposit(request, totalCents) {
  var schedule = _BookingRequest2.default.paymentSchedule(request);
  var depositPaymentAmount = _getFirstCompletedPaymentAmount(schedule);

  if (_isFinite(depositPaymentAmount)) {
    return depositPaymentAmount;
  }

  // if no admin override, see if host override
  var hostDepositCents = (0, _lodash.get)(request, 'host.depositCents');
  if (_isFinite(hostDepositCents)) {
    return _round(hostDepositCents);
  } else {
    return totalCents < MINIMUM_SPEND ? _round(MINIMUM_SPEND) : _round(totalCents / 2);
  }

  function _getFirstCompletedPaymentAmount(payments) {
    var firstPayment = (0, _lodash.find)(payments, function (p) {
      return (0, _lodash.get)(p, 'state') === 'COMPLETED';
    });
    if (firstPayment && _isFinite(firstPayment.amountCents)) {
      return firstPayment.amountCents;
    }
  }
}

/**
 * foodBeverageMin, returns the food and beverage min cents
 * @param {Request} request
 * @return {Number}
 */

function foodBeverageMin(request) {
  var foodBeverageMinCents = request.host ? request.host.foodBeverageMinCents : undefined;
  return _isFinite(foodBeverageMinCents) ? foodBeverageMinCents : 0;
}

/**
 * balanceOutstanding, returns the balance outstanding for the current request
 * @param {Request} request
 * @param {Number} total
 * @return {Number}
 */
function balanceOutstanding(request, total) {
  var hasCancellationRefund = checkCancellationRefund(request);
  if (_isFinite((0, _lodash.get)(request, 'admin.resolutionTransaction.amountCents')) || hasCancellationRefund) {
    return 0;
  }
  var sumPayments = amountPaid(request);

  // show negative balance in case we need to return money to the guest
  var balance = (_isFinite(total) ? total : 0) - sumPayments;
  return Math.round(balance);
}

function checkCancellationRefund(request) {
  var schedule = (0, _lodash.get)(request, 'data.payment.schedule', []);
  if (!schedule.length) {
    return false;
  }

  var lastSchedule = schedule[schedule.length - 1];

  if (lastSchedule.state === 'REFUNDED' && lastSchedule.descriptor === 'CANCELLATION_REFUND') {
    return true;
  }

  return false;
}

/**
 * This function gets the refunded amount
 * Note: the refunded amount is not necessarily equal to the amount that should be refunded
 */

function refundedAmount(request) {
  // check if any amount is refunded
  var schedule = _BookingRequest2.default.paymentSchedule(request);
  var refundedPayments = schedule.filter(function (p) {
    return p.state === 'REFUNDED';
  });
  var totalRefunded = calculateTotalRefunded(refundedPayments);
  var resolutionTransactionAmount = 0;

  var resolutionTransaction = (0, _lodash.get)(request, 'admin.resolutionTransaction');

  if (resolutionTransaction && resolutionTransaction.paymentType && resolutionTransaction.paymentType.includes('refund')) {
    resolutionTransactionAmount = resolutionTransaction.amountCents;
  }

  return totalRefunded + resolutionTransactionAmount;
}

function calculateTotalRefunded(refundedPayments) {
  if (!refundedPayments) {
    return 0;
  }

  var totalRefund = 0;
  refundedPayments.forEach(function (p) {
    totalRefund += p.amountCents;
  });

  return totalRefund;
}

/**
 * This function gets the extra charge amount
 */

function extraChargeAmount(request) {
  var resolutionTransaction = (0, _lodash.get)(request, 'admin.resolutionTransaction');

  if (resolutionTransaction && resolutionTransaction.paymentType === 'cancellation charge') {
    return resolutionTransaction.amountCents;
  }
  return 0;
}

/**
 * This function calculates the amount actually paid by going through the payment schedule
 */

function amountPaid(request) {
  var payments = void 0;
  if ((0, _lodash.get)(request, 'data.payment.schedule.length')) {
    payments = request.data.payment.schedule;
  } else {
    return 0;
  }

  var completedPayments = (0, _lodash.filter)(payments, function (payment) {
    return payment && payment.state === 'COMPLETED';
  });

  if (!completedPayments.length) {
    return 0;
  }

  var paid = 0;
  (0, _lodash.each)(completedPayments, function (payment) {
    var paymentAmount = (0, _lodash.get)(payment, 'amountCents');
    paid += _isFinite(paymentAmount) ? paymentAmount : 0;
  });

  if (refundedAmount(request)) {
    paid -= refundedAmount(request);
  }

  if (extraChargeAmount(request)) {
    paid += extraChargeAmount(request);
  }

  return paid;
}

function bookingFee(request) {
  var actualSuccessFee = (0, _lodash.get)(request, 'admin.resolutionTransaction.successFeeCents');

  if (_isFinite(actualSuccessFee)) {
    return actualSuccessFee;
  }

  var _foodAndBeverageTotal = foodAndBeverageTotal(request);
  var _roomFee = roomFee(request);
  var commissionTotal = _foodAndBeverageTotal + _roomFee;
  var commissionPercentage = _BookingRequest2.default.hostCommissionPercentage(request);

  var fee = commissionTotal * (_isFinite(commissionPercentage) ? commissionPercentage / 100 : 0);

  return Math.round(fee);
}

function ownerCommission(request) {
  var VP_OWNER_COMMISSION_MULTIPLE = 0.1;
  var PVP_OWNER_COMMISSION_MULTIPLE = 0.005;

  var actualSuccessFee = (0, _lodash.get)(request, 'admin.resolutionTransaction.successFeeCents');
  var calculatedSuccessFee = bookingFee(request);
  var calculatedAmountPaid = amountPaid(request);

  if (actualSuccessFee) {
    return Math.round(VP_OWNER_COMMISSION_MULTIPLE * actualSuccessFee);
  } else if (calculatedSuccessFee) {
    return Math.round(VP_OWNER_COMMISSION_MULTIPLE * calculatedSuccessFee);
  } else if ((0, _lodash.get)(request, 'admin.resolutionTransaction.paymentType')) {
    return Math.round(PVP_OWNER_COMMISSION_MULTIPLE * calculatedAmountPaid);
  } else {
    return Math.round(PVP_OWNER_COMMISSION_MULTIPLE * (foodAndBeverageTotal(request) + roomFee(request)));
  }
}

function cardFee(request) {
  var actualProcessingFee = (0, _lodash.get)(request, 'admin.resolutionTransaction.processingFeeCents');

  if (_isFinite(actualProcessingFee)) {
    return actualProcessingFee;
  }

  var cardFeePercentage = _BookingRequest2.default.cardFeePercentage(request);

  var fee = total(request) * (_isFinite(cardFeePercentage) ? cardFeePercentage / 100 : 0);

  return Math.round(fee);
}

function total(request) {
  return _round(foodAndBeverageTotal(request) + nonFoodAndBeverageTotal(request) + adminFee(request) + roomFee(request) + foodAndBeverageTax(request) + nonFoodAndBeverageTax(request) + nonTaxableTotal(request) + gratuity(request) + customFees(request));
}

function directToVenueTotal(request) {
  var schedule = (0, _lodash.get)(request, 'data.payment.schedule', []);
  var directPayments = schedule.filter(function (payment) {
    return payment && payment.isDirectToVenue;
  });
  return directPayments.reduce(function (total, payment) {
    return total + payment.amountCents;
  }, 0);
}

function payout(request) {
  var finalPayout = (0, _lodash.get)(request, 'admin.payout.amountDollars');

  if ((0, _lodash.isFinite)(finalPayout)) {
    var finalPayoutCents = finalPayout * 100;
    var venuePayments = (0, _lodash.get)(request, 'admin.venuePayments', []).map(function (payment) {
      return payment.amountDollars;
    });

    return finalPayoutCents + (0, _lodash.sum)(venuePayments) * 100;
  }

  return total(request) - bookingFee(request) - cardFee(request);
}

/**
 * convert fullPriceBreakdownCents to dollars, and prepend currency if desired
 * @param {Request} request
 * @param {Boolean} prependCurrency if true
 * @return {Ret}
 */
function fullPriceBreakdownDollars(request, prependCurrency) {
  var ret = {};
  var currSymbol = '';
  if (prependCurrency) {
    currSymbol = getCurrency(request);
  }

  (0, _lodash.each)(fullPriceBreakdownCents(request), function (val, key) {
    if (Array.isArray(val)) {
      ret[key] = val.map(function (fee) {
        var dollars = convertToDollarsAndRound(fee.value);
        var value = currSymbol + (0, _commafy2.default)(dollars);
        fee.value = value;
        return fee;
      });
    }
    var dollars = convertToDollarsAndRound(val);
    ret[key] = currSymbol + (0, _commafy2.default)(dollars);
  });
  return ret;
}

/**
 * Gets the currency for payments for a given request
 *
 * @param {Request}
 * @return {String}
 */
function getCurrency(request) {
  var iso = (0, _lodash.get)(request, 'data.payment.currency');
  return _currencies2.default[iso] || _currencies2.default[DEFAULT_CURRENCY];
}

/**
 * This function MUST be used when converting to dollars for payments.
 * This is also the only place where rounding should take place. Otherwise,
 * we'll get amounts off by 1 or 2 cents which will cause issues, particularly when
 * the balance outstanding is less than 0.
 *
 * @param {Number} cents
 * @return {String}
 */
function convertToDollarsAndRound(cents) {
  var dollars = (_isFinite(cents) ? cents : 0) / 100;
  return (0, _lodash.round)(dollars, 2).toFixed(2);
}

function _round(num) {
  return Math.round(num);
}

function _isFinite(num) {
  return (0, _lodash.isFinite)(num);
}

exports.fullPriceBreakdownCents = fullPriceBreakdownCents;
exports.foodAndBeverageTotalCents = foodAndBeverageTotal;
exports.nonFoodAndBeverageTotalCents = nonFoodAndBeverageTotal;
exports.customFeesCents = customFees;
exports.customFeesList = customFeesList;
exports.customFeeCents = customFee;
exports.adminFeeCents = adminFee;
exports.foodAndBeverageTaxCents = foodAndBeverageTax;
exports.nonFoodAndBeverageTaxCents = nonFoodAndBeverageTax;
exports.gratuityCents = gratuity;
exports.fbMinRangeDollars = fbMinRangeDollars;
exports.roomFeeRange = roomFeeRange;
exports.extraToMeetMinimumSpendCents = extraToMeetMinimumSpend;
exports.roomFeeCents = roomFee;
exports.menuAndDrinkTotalCents = menuAndDrinkTotalCents;
exports.depositCents = deposit;
exports.foodBeverageMinCents = foodBeverageMin;
exports.balanceOutstandingCents = balanceOutstanding;
exports.overageTotal = overageTotal;
exports.amountPaid = amountPaid;
exports.ownerCommission = ownerCommission;
exports.bookingFee = bookingFee;

exports.fullPriceBreakdownDollars = fullPriceBreakdownDollars;
exports.directToVenueTotal = directToVenueTotal;

exports.getCurrency = getCurrency;
exports.convertToDollarsAndRound = convertToDollarsAndRound;